module.exports = __webpack_public_path__ + "img/site-seguro-blindado.947811ba.png";